// @ts-nocheck
import React from 'react';
import CC from './CC';
import MBWay from './MBWay';
import Multibanco from './Multibanco';
import CashPayment from './CashPayment';
import DigitalWallet from './DigitalWallet';


const Method = ({
                    method,
                    value,
                    formReplies,
                    fixedValue,
                    itemPurchases,
                    donations,
                    email,
                    onEmailChange
                }) => {

    switch (method) {

        case 'Multibanco':
            return (
                <Multibanco
                    value={value}
                    formReplies={formReplies}
                    fixedValue={fixedValue}
                    itemPurchases={itemPurchases}
                    donations={donations}
                    email={email}
                    onEmailChange={onEmailChange}
                />
            );


        case 'Cartão de Crédito':
            return (
                <CC
                    value={value}
                    formReplies={formReplies}
                    fixedValue={fixedValue}
                    itemPurchases={itemPurchases}
                    donations={donations}
                    email={email}
                    onEmailChange={onEmailChange}
                />
            );


        case 'MB WAY':
            return (
                <MBWay
                    value={value}
                    formReplies={formReplies}
                    fixedValue={fixedValue}
                    itemPurchases={itemPurchases}
                    donations={donations}
                    email={email}
                    onEmailChange={onEmailChange}
                />
            );


        case 'Google Pay':
            return (
                <DigitalWallet
                    provider="Google Pay"
                    endpoint="googlepay"
                    successMethod="googlepay"
                    value={value}
                    formReplies={formReplies}
                    fixedValue={fixedValue}
                    itemPurchases={itemPurchases}
                    donations={donations}
                    email={email}
                    onEmailChange={onEmailChange}
                />
            );


        case 'Apple Pay':
            return (
                <DigitalWallet
                    provider="Apple Pay"
                    endpoint="applepay"
                    successMethod="applepay"
                    value={value}
                    formReplies={formReplies}
                    fixedValue={fixedValue}
                    itemPurchases={itemPurchases}
                    donations={donations}
                    email={email}
                    onEmailChange={onEmailChange}
                />
            );


        case 'Numerário':
            return (
                <CashPayment
                    value={value}
                    formReplies={formReplies}
                    fixedValue={fixedValue}
                    itemPurchases={itemPurchases}
                    donations={donations}
                />
            );


        default:
            return null;
    }
};


export default Method;